import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { dlnCatchResponse } from '@delen/extensions';
import { EMPTY, throwError } from 'rxjs';
import { AppRoute } from 'src/app/app.route';
import { redirectToVerification } from './authentication-redirect.helper';
import { AuthenticationStore } from './authentication.store';

/**
 * Handles 401 Unauthorized errors by redirecting to verification page.
 * Does NOT redirect when already on any login route (verification or confirmation).
 */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);
  const authStore = inject(AuthenticationStore);

  return next(req).pipe(
    dlnCatchResponse((err) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== HttpStatusCode.Unauthorized) {
        return throwError(() => err);
      }

      const isOnLoginRoute = router.url.includes(`/${AppRoute.Login}/`);

      if (isOnLoginRoute) {
        return throwError(() => err);
      }

      redirectToVerification(router, activatedRoute, authStore);
      return EMPTY;
    }),
  );
};
